import React, { Component } from 'react';
import { connect } from 'react-redux';
import { notificationsActions } from '../../../data/actions/notifications';
import store from '../../../helpers/store';
import Spinner from '../../common/Spinner';
import ChangelogCard from './ChangelogCard';

const closeSvg = require('!svg-inline-loader!../../../../public/img/cross.svg');

class Changelog extends React.Component {
	constructor(props){
		super(props);
		this.load = this.load.bind(this);
		this.close = this.close.bind(this);

		this.state = {
			closing: false
		}
	}

	componentDidMount() {
	}
	
	load(){
		this.props.dispatch(notificationsActions.getChangelog());	
	}
	
	close(){
		// play slide-out animation first, then close panel
		if (this.state.closing) return;
		this.setState({ closing: true });
		setTimeout(() => {
			this.props.dispatch(notificationsActions.setChangelogPanel(false));
			document.body.style.overflow = "auto";
			this.setState({ closing: false });
		}, 320);
	}

	componentDidUpdate(prevProps) {
		// If panel was closed externally, play slide-out before fully unmounting
		const prevOpen = prevProps.notifications && prevProps.notifications.changelogPanel;
		const nowOpen = this.props.notifications && this.props.notifications.changelogPanel;
		if (prevOpen && !nowOpen && !this.state.closing) {
			this.setState({ closing: true });
			const ANIM_MS = 320;
			setTimeout(() => {
				this.setState({ closing: false });
			}, ANIM_MS);
		}
	}

	
	render() {
		const { changelogPanel, changelogLoading, changelog } = this.props.notifications;
		// keep rendering while closing so we can animate slide-out
		if(!changelogPanel && !this.state.closing)
			return null;
			
		const holderClass = `changelog-holder${this.state.closing ? ' closing' : ''}`;
		return <div>
			<div className="changelog-main-container">
				<div className={holderClass}>
					<div className="changelog-holder-title">
						<h3 className="changelog-holder-title-text">What's New</h3>
						<span className="close-modal-btn" onClick={this.close} dangerouslySetInnerHTML={{__html: closeSvg}}></span>
					</div>
					{changelog && changelog.length !== 0 && 
						<div className="changelog-holder-list">
							{ changelog.map(entry=><ChangelogCard key={entry.id} entry={entry} />)}
						</div>
					}
					<div className="changelog-load-btn-container">
						{changelog && changelog.length == 0 && <span>No new changelog entries. Click Load all to read previous.</span>}
						<a onClick={this.load} className="default-btn default-btn--small button">Load All</a>
						{changelogLoading && <div className="whats-new-spinner"><Spinner enabled={true} /></div>}
					</div>
				</div>
			</div>
		</div>
	}
}

function mapStateToProps(state) {
	return {
		notifications: state.notifications
	} 
}

export default connect(mapStateToProps)(Changelog);